import Login from "@/views/authentication/Login.vue";
import MainLayout from "@/views/main/layouts/MainLayout.vue";
import Home from "@/views/main/Home.vue";
import POS from "@/views/main/pages/pos/POS.vue";
import Products from "@/views/main/pages/products/Products.vue";
import Inventory from "@/views/main/pages/inventory/Inventory.vue";
import SalesHistory from "@/views/main/pages/sales/SalesHistory.vue";
import Customers from "@/views/main/pages/customers/Customers.vue";
import CashDrawer from "@/views/main/pages/cash-drawer/CashDrawer.vue";
import Suppliers from "@/views/main/pages/suppliers/Suppliers.vue";
import StockReceipts from "@/views/main/pages/suppliers/StockReceipts.vue";
import Transfers from "@/views/main/pages/transfers/Transfers.vue";
import Reports from "@/views/main/pages/reports/Reports.vue";
import Accounting from "@/views/main/pages/accounting/Accounting.vue";
import PurchaseOrders from "@/views/main/pages/purchase-orders/PurchaseOrders.vue";
import Promotions from "@/views/main/pages/promotions/Promotions.vue";
import QuickKeys from "@/views/main/pages/pos-admin/QuickKeys.vue";
import Settings from "@/views/main/pages/settings/Settings.vue";
import Users from "@/views/main/pages/users/Users.vue";
import JwtService from "@/core/services/jwt.service";

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { guest: true },
  },
  {
    path: "/",
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      { path: "", redirect: "/home" },
      { path: "home", name: "home", component: Home },
      { path: "pos", name: "pos", component: POS, meta: { permission: "SALE" } },
      { path: "sales", name: "sales", component: SalesHistory, meta: { permission: "SALE" } },
      { path: "cash-drawer", name: "cash-drawer", component: CashDrawer, meta: { permission: "SALE" } },
      { path: "customers", name: "customers", component: Customers, meta: { permission: "INVENTORY_VIEW" } },
      { path: "products", name: "products", component: Products, meta: { permission: "INVENTORY_VIEW" } },
      { path: "suppliers", name: "suppliers", component: Suppliers, meta: { permission: "INVENTORY_VIEW" } },
      { path: "stock-receipts", name: "stock-receipts", component: StockReceipts, meta: { permission: "INVENTORY_VIEW" } },
      { path: "purchase-orders", name: "purchase-orders", component: PurchaseOrders, meta: { permission: "INVENTORY_VIEW" } },
      { path: "inventory", name: "inventory", component: Inventory, meta: { permission: "INVENTORY_VIEW" } },
      { path: "transfers", name: "transfers", component: Transfers, meta: { permission: "INVENTORY_VIEW" } },
      { path: "reports", name: "reports", component: Reports, meta: { permission: "REPORTS_VIEW" } },
      { path: "accounting", name: "accounting", component: Accounting, meta: { permission: "ACCOUNTING_VIEW" } },
      { path: "users", name: "users", component: Users, meta: { permission: "USER_MANAGE" } },
      { path: "promotions", name: "promotions", component: Promotions, meta: { permission: "USER_MANAGE" } },
      { path: "quick-keys", name: "quick-keys", component: QuickKeys, meta: { permission: "USER_MANAGE" } },
      { path: "settings", name: "settings", component: Settings, meta: { permission: "USER_MANAGE" } },
    ],
  },
  { path: "*", redirect: "/home" },
];

export default routes;

export function createRouterGuard(router, store) {
  router.beforeEach((to, from, next) => {
    const token = JwtService.getToken();
    const authed = !!token && store.getters.isAuthenticated;

    if (to.matched.some((r) => r.meta.requiresAuth) && !authed) {
      return next({ name: "login" });
    }
    if (to.meta.guest && authed) {
      return next({ name: "home" });
    }
    const perm = to.meta.permission;
    if (perm && authed && !store.getters.hasPermission(perm)) {
      let fallback = "home";
      if (to.name !== fallback) {
        return next({ name: fallback });
      }
    }
    next();
  });
}
